export default __webpack_public_path__ + "static/media/netflix_background2.89a2a374.jpeg";